import { NativeDateAdapter } from '@angular/material/core';

export class UTCDateAdapter extends NativeDateAdapter {
   override createDate(year: number, month: number, date: number): Date {
      return new Date(Date.UTC(year, month, date));
   }

   override toIso8601(date: Date): string {
      return date.toISOString();
   }

   override parse(value: any): Date | null {
      // saját parsing logika itt, ha kell
      return super.parse(value);
   }
}
